var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "application-page jobs" },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [_c("Navigation", { attrs: { page: "jobs" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c("h1", [_vm._v(_vm._s(_vm.title))]),
                  _vm._v(" "),
                  _vm.job
                    ? [
                        _c("div", { staticClass: "job-listing" }, [
                          _c("div", { staticClass: "job-listing--items" }, [
                            _c(
                              "div",
                              { staticClass: "job-listing--item" },
                              [
                                _c("DisplayNew", {
                                  attrs: { job: _vm.job, teaser: "" }
                                })
                              ],
                              1
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("Listing", {
                          staticClass: "mt-4",
                          attrs: {
                            job: _vm.job,
                            "filter-values": _vm.filterValues,
                            "only-favorites": _vm.onlyFavorites
                          },
                          on: { loaded: _vm.listingLoaded }
                        })
                      ]
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }